import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import url from "../../../../config/axios";
import { publishImage } from "../../../../helpers/imageupload";
import { FailedNotify } from "../../../../constants/tostify";

const ProfileInformationForm = ({ newdata, setNewdata }) => {
  const { name } = useSelector((state) => state.user);
  const [displaytext, setDisplaytext] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewdata((prev) => ({
      ...prev,
      profileInformation: {
        ...prev.profileInformation,
        [name]: value,
      },
    }));
  };

  // Handle image upload
  const onDrop = async (acceptedFiles) => {
    setDisplaytext("Uploading...");
    try {
      const uploaded = await publishImage(acceptedFiles);
      setNewdata((prev) => ({
        ...prev,
        profileInformation: {
          ...prev.profileInformation,
          photo: uploaded.toString(),
        },
      }));
      setDisplaytext("");
    } catch (err) {
      FailedNotify("Image upload failed!");
      setDisplaytext("");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const pi = newdata?.profileInformation || {};

  return (
    <div>
      <Row>
        <Col md={3}>
          <Form.Label className="custm-lble">First Name</Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            value={pi.firstName || ""}
            placeholder="First Name"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Last Name</Form.Label>
          <Form.Control
            type="text"
            name="lastName"
            value={pi.lastName || ""}
            placeholder="Last Name"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Job Designation</Form.Label>
          <Form.Control
            type="text"
            name="jobDesignation"
            value={pi.jobDesignation || ""}
            placeholder="Job Designation"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Email</Form.Label>
          <Form.Control
            type="text"
            name="email"
            value={pi.email || ""}
            placeholder="Email"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Label className="custm-lble">Primary Number</Form.Label>
          <Form.Control
            type="text"
            name="primaryNumber"
            value={pi.primaryNumber || ""}
            placeholder="Primary Number"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Secondary Number</Form.Label>
          <Form.Control
            type="text"
            name="secondaryPhone"
            value={pi.secondaryPhone || ""}
            placeholder="Secondary Number"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Address Line 1</Form.Label>
          <Form.Control
            type="text"
            name="addressLine1"
            value={pi.addressLine1 || ""}
            placeholder="Address Line 1"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Address Line 2</Form.Label>
          <Form.Control
            type="text"
            name="addressLine2"
            value={pi.addressLine2 || ""}
            placeholder="Address Line 2"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Label className="custm-lble">Permanent Address</Form.Label>
          <Form.Control
            type="text"
            name="permanentResidence"
            value={pi.permanentResidence || ""}
            placeholder="Permanent Address"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Postal Code</Form.Label>
          <Form.Control
            type="text"
            name="postalcode"
            value={pi.postalcode || ""}
            placeholder="Postal Code"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Gender</Form.Label>
          <Form.Control
            type="text"
            name="gender"
            value={pi.gender || ""}
            placeholder="Gender"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Date of Birth</Form.Label>
          <Form.Control
            type="text"
            name="dob"
            value={pi.dob || ""}
            placeholder="Date of Birth"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Label className="custm-lble">Country of Birth</Form.Label>
          <Form.Control
            type="text"
            name="cob"
            value={pi.cob || ""}
            placeholder="Country of Birth"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Place of Birth</Form.Label>
          <Form.Control
            type="text"
            name="pob"
            value={pi.pob || ""}
            placeholder="Place of Birth"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Nationality</Form.Label>
          <Form.Control
            type="text"
            name="nationality"
            value={pi.nationality || ""}
            placeholder="Nationality"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">ID Type</Form.Label>
          <Form.Control
            type="text"
            name="idType"
            value={pi.idType || ""}
            placeholder="ID Type"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Label className="custm-lble">ID Number</Form.Label>
          <Form.Control
            type="text"
            name="idNumber"
            value={pi.idNumber || ""}
            placeholder="ID Number"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Marital Status</Form.Label>
          <Form.Control
            type="text"
            name="martialStatus"
            value={pi.martialStatus || ""}
            placeholder="Marital Status"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Visa Status</Form.Label>
          <Form.Control
            type="text"
            name="visaStatus"
            value={pi.visaStatus || ""}
            placeholder="Visa Status"
            onChange={handleChange}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="custm-lble">Job Title</Form.Label>
          <Form.Control
            type="text"
            name="jobTitle"
            value={pi.jobTitle || ""}
            placeholder="Job Title"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Label className="custm-lble">Portfolio Link</Form.Label>
          <Form.Control
            type="text"
            name="portfolioLink"
            value={pi.portfolioLink || ""}
            placeholder="Portfolio Link"
            onChange={handleChange}
          />
        </Col>

        <Col md={3}>
          <Form.Label className="custm-lble">Upload Photo</Form.Label>
          <div {...getRootProps()} className="cursor_P d-flex align-items-center">
            <CameraAltIcon style={{ marginRight: 5 }} />
            <input {...getInputProps()} />
            {displaytext && <span>{displaytext}</span>}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProfileInformationForm;
